import type { NoteOut } from '@/services/noteGoApi/noteGoApiSchemas';
import { SECOND_BRAIN_NOTES_LIMIT } from '@/features/secondBrain/config';

const QUESTION_WORDS = new Set(
  'a about an and are as at be been but by can could did do does down for from had has have here how i if in into is it last me my not note notes of on or our out over please recording said say show so tell that the their then there these this to too up very video was we week were what when where which who why will with would you your'.split(
    ' ',
  ),
);

// Mirror the backend index tokenizer: punctuation is deleted (not split on), so
// "sign-up" → "signup" and "don’t" → "dont"; underscores are kept.
const words = (text: string) =>
  text
    .toLowerCase()
    .replace(/[^\p{L}\p{N}_\s]/gu, '')
    .split(/\s+/)
    .filter((word) => word.length > 1);

// Keep the indexed keyword query bounded, even for a long question.
export const getQuestionKeywords = (question: string): string[] =>
  [...new Set(words(question))].filter((word) => !QUESTION_WORDS.has(word)).slice(0, 10);

export const rankContextNotes = (notes: NoteOut[], keywords: string[]): NoteOut[] =>
  notes
    .map((note) => {
      const title = new Set(words(note.title ?? ''));
      const tags = new Set(words((note.tags ?? []).join(' ')));
      const summary = new Set(words(note.summary ?? ''));
      const indexedWords = new Set(note.search_keywords ?? []);
      const score = keywords.reduce(
        (total, word) =>
          total +
          Number(title.has(word)) * 4 +
          Number(tags.has(word)) * 3 +
          Number(summary.has(word)) * 2 +
          Number(indexedWords.has(word)),
        0,
      );
      return { note, score };
    })
    // Preserve the server's newest-first order for equally relevant notes.
    .sort((a, b) => b.score - a.score)
    .slice(0, SECOND_BRAIN_NOTES_LIMIT)
    .map(({ note }) => note);
